module.exports = __webpack_public_path__ + "static/img/file_conten.c69d5ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/file_conten.png
// module id = grJl
// module chunks = 1